import {
  createRouter as _createRouter,
  createWebHistory,
  RouterOptions as RawRouterOptions
} from 'vue-router'

export function createRouter(options: Omit<RawRouterOptions, 'history'>) {
  return _createRouter({
    ...options,
    history: createWebHistory()
  })
}
